<template>
  <div class="table-header">
    <div class="box-links">
      <div>
        <h3>Invoice</h3>
      </div>
      <div class="links">
        <template v-for="(link, index) in links">
          <span
            :class="{ active: index == cIndexActual }"
            :key="index"
            @click="newIndex(index)"
          >
            {{ link.name }}
          </span>
        </template>
      </div>
    </div>
    <template v-if="button">
      <div class="table-action">
        <div class="meta-pay" :class="{active: cActive}" @click="$emit('sendMetaPay')">
        <img
          v-if="!cActive"
          src="./../../assets/icons/metaPayDisable.svg"
          alt="Process through MetaPay"
        />
        <img
          v-if="cActive"
          src="./../../assets/icons/metaPayEnable.svg"
          alt="Process through MetaPay"
        />
          Process through MetaPay
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'header-table',
  data() {
    return {
      message: '',
      links: [
        { name: 'Invoice registry' },
        { name: 'Incoming invoices' },
        // { name: 'Archived invoices' },
      ],
      indexTable: 0,
    };
  },
  props: {
    button: {
      type: Boolean,
    },
    buttonAction: {
      type: Boolean,
    },
  },

  methods: {
    newIndex(index) {
      this.$store.commit('UPDATE_TABLE', index);
    },
  },
  computed: {
    cActive() {
      if (this.buttonAction) {
        return true;
      }
      return false;
    },
    cIndexActual() {
      return this.$store.getters.tableIndex;
    },
  },
};
</script>
<style lang="scss" scoped>
.table-header {
  width: 92.4vw;
  margin: 25px auto 0px;
  /* position: relative; */
  height: 84px;
  display: flex;
  padding: 0 28px;
  color: $header;
  background-color: $white;
  justify-content: space-between;
  border-bottom: 1px solid $backgroundData;
  border-radius: 5px 5px 0 0;

  .box-links {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h3 {
      padding-top: 10px;
      text-align: left;
      font-size: 1.6rem;
      font-weight: 600;
    }

    .links {
      display: flex;

      span {
        position: relative;
        cursor: pointer;
        margin-right: 96px;
        font-size: 1rem;
        font-weight: 400;
        &:last-child {
          margin-right: 0;
        }
      }
      .active {
        border-bottom: 1px solid $header;
      }
    }
  }

  .table-action {
    display: flex;
    align-items: center;
    .meta-pay {
      display: flex;
      align-items: center;
      font-size: .87rem;
      height: 37px;
      padding: 0px 14px;
      border-radius: 40px;
      background-color: $backgroundData;
      color: $disabled;
      cursor: default;
      &.active {
        cursor: pointer;
        background-color: $backgroundData;
        border: 2px solid $header;
        color: $header;
      }
      &.green {
        border: 2px solid $payed !important;
        background-color: $backgroundPayed !important;
        color: $payed;
      }
      img {
        margin-right: 16px;
      }
    }
  }
}
</style>
